<header class="page-topbar">
  <div class="layout-width">
    <div class="app-header">
      <div class="header-left"></div>
      <div class="header-right">
        <!-- <div class="header-right-item preview-section">
        <span class="preview-text" (click)="navigateToPreview()">Preview Shop</span>
      </div> -->
        <!-- <button class="btn-danger" (click)="navigateToPOS()"><img src="../../../assets/icons/pos.svg" alt="" *ngIf="showPOS"> POS</button> -->
        <div class="header-right-item">
          <div class="lang-wrapper">
            <button class="lang-btn" (click)="open = !open">
              <img [src]="selectedLang.flag" class="flag-img" [alt]="selectedLang.label" />
              <span class="text">{{ selectedLang.label }}</span>
              <span class="caret" [class.rotate]="open"></span>
            </button>

            <div class="lang-dropdown" *ngIf="open">
              <span class="dropdown-arrow"></span>

              <div
                class="lang-option"
                *ngFor="let lang of languages; trackBy: trackByIndex"
                [class.active]="lang.code === selectedLang.code"
                (click)="onLanguageChange(lang.code)"
              >
                <img [src]="lang.flag" class="flag-img" />
                <span class="label">{{ lang.label }}</span>
              </div>
            </div>

            @if (isLangLoading) {
            <div class="lang-loader">
              <span class="spinner"></span>
            </div>
            }
          </div>
        </div>

        <!-- TODO: Parag to review and get back in this. Free Trial badge hidden for now.
        @if (subscriptionPlan?.isFreeTrial) {
        <div class="trail-box" (click)="navigateToTrial()">
          <img src="../../../assets/icons/alert-triangle.svg" />
          @if (!isTrialExpired) {
          <p>Free Trial: {{ daysRemaining }} days remaining</p>
          } @if (isTrialExpired) {
          <p>Free Trial: Expired</p>
          }
        </div>
        }
-->
        <div id="hidden_translate_element" style="display: none"></div>

        @if('store_notification.view' | hasPermission){
        <div class="header-right-item" (click)="toggleNotifications($event)">
          <img src="../../../assets/images/notification-icon.svg" class="notification-icon" />
          @if (!!unreadCount) {
          <p class="notification-badge">{{ unreadCount }}</p>
          } </div
        >}
        <div class="header-right-item" (click)="navigateToSetting()">
          <img src="../../../assets/images/settings-icon.svg" />
        </div>
        <div class="header-right-item">
          <div class="profile-photo-section">
            <img src="../../../assets/icons/user.svg" (click)="toggleUserDropdown($event)" />
          </div>
          @if (showUserDropdown) {
          <div
            class="user-dropdown-wrapper"
            [attr.style]="direction == 'rtl' ? 'right: -95px !important;' : ''"
            (click)="$event.stopPropagation()"
          >
            <div class="user-dropdown">
              @if (showStoreSetting) {
              <div class="user-dropdown-name" (click)="navigateToMyAccount($event)">
                <div class="drp-icon">
                  <img src="../../../assets/images/account-circle.svg" />
                </div>
                <div class="drp-text">
                  <span>{{ 'ui_my_account_lbl' | translate }}</span>
                </div>
              </div>
              } @if (showStoreSetting) {
              <div class="user-dropdown-name" (click)="navigateToStoreSetting($event)">
                <div class="drp-icon">
                  <!-- <img src="../../../assets/images/store-setting-80.png" /> -->
                  <img src="../../../assets/images/store-setting-96.png" />
                </div>
                <div class="drp-text">
                  <span>{{ 'ui_store_settings_lbl' | translate }}</span>
                </div>
              </div>
              }
              <div class="user-dropdown-name" (click)="navigateToGetStarted($event)">
                <div class="drp-icon">
                  <img src="../../../assets/images/store-ecommerce.svg" />
                </div>
                <div class="drp-text">
                  <span>{{ 'ui_add_store_lbl' | translate }}</span>
                </div>
              </div>
              <div class="user-dropdown-name" (click)="navigateToPreview()">
                <div class="drp-icon">
                  <img src="../../../assets/images/eye-icon2.svg" />
                </div>
                <div class="drp-text">
                  <span>{{ 'ui_preview_shop_lbl' | translate }}</span>
                </div>
              </div>
              <div class="user-dropdown-name" (click)="logout()">
                <div class="drp-icon">
                  <img src="../../../assets/images/logout.svg" />
                </div>
                <div class="drp-text">
                  <span>{{ 'ui_logout_lbl' | translate }}</span>
                </div>
              </div>
            </div>
          </div>
          }

          <!---------------------------------------------Notifications------------------------------------ -->
          @if (showNotifications) {
          <div class="notification-wrapper" ngbDropdown (click)="$event.stopPropagation()">
            <!-- <button
            type="button"
            class="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
            id="page-header-notifications-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            ngbDropdownToggle
            >
            <i class="bx bx-bell fs-22"></i>
            <span
              class="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger"
              ><span class="visually-hidden">unread messages</span></span
              >
            </button> -->
            <div class="notification-container">
              <!-- Header -->
              <div class="notifications-header">
                <div class="notifications-heading">
                  <p>{{ 'ui_notifications_lbl' | translate }}</p>
                  <p class="new-notifications">{{ unreadCount }} {{ 'ui_new_lbl' | translate }}</p>
                </div>
                <div class="notifications-header-actions">
                  <!-- Option A: Minimal icon in header -->
                  <span
                    class="sound-icon-minimal"
                    [class.sound-muted]="isSoundMuted"
                    (click)="toggleMasterSound(); $event.stopPropagation()"
                  >
                    <span class="material-icons">{{ isSoundMuted ? 'volume_off' : 'volume_up' }}</span>
                  </span>
                  @if (unreadCount) {
                  <button class="mark-all-read-btn" (click)="markAllRead(); $event.stopPropagation()">
                    <span class="material-icons" style="font-size: 14px">done_all</span>
                    Mark all read
                  </button>
                  }
                </div>
              </div>

              <!-- Filter Tabs -->
              <div class="notification-filter-tabs">
                @for (tab of filterTabs; track tab.key) {
                <button
                  class="filter-tab"
                  [class.filter-tab-active]="activeNotificationsTab === tab.key"
                  (click)="onTabChange(tab.key)"
                >
                  {{ tab.label }}
                  @if (tabUnreadCounts[tab.key]) {
                  <span class="tab-count-badge">{{ tabUnreadCounts[tab.key] }}</span>
                  }
                </button>
                }
              </div>

              <!-- Grouped List -->
              <div class="notifications-list">
                @if (groupedNotifications.length) { @for (group of groupedNotifications; track group.label) {
                <div class="notification-time-group">
                  <div class="time-group-header">{{ group.label }}</div>
                  @for (item of group.items; track item._id) {
                  <div
                    class="notification-card"
                    (click)="updateNotificationStatus(item)"
                    [class.notification-unread]="!item.isOpened"
                  >
                    <div
                      class="notification-type-icon"
                      [style.backgroundColor]="getNotificationMeta(item).bgColor"
                      [style.color]="getNotificationMeta(item).color"
                    >
                      <span class="material-icons">{{ getNotificationMeta(item).icon }}</span>
                    </div>
                    <div class="notification-content">
                      <p class="notification-title">{{ item.notification.title }}</p>
                      <p class="notification-body">{{ item.notification.body }}</p>
                      <p class="notification-card-date">{{ getRelativeTime(item.createdAt) }}</p>
                    </div>
                    @if (!item.isOpened) {
                    <div class="notification-unread-dot"></div>
                    }
                  </div>
                  }
                </div>
                } } @else {
                <div class="notifications-alerts">
                  <img src="../../../assets/icons/bell.svg" class="alert-icon" />
                  <p>{{ 'ui_no_notifications_msg_lbl' | translate }}</p>
                </div>
                }
              </div>

              <!-- Footer -->
              <div class="notifications-footer">
                <a
                  class="view-all-link"
                  routerLink="/store-setting/notification-settings/admin-notifications"
                  (click)="showNotifications = false"
                >
                  View All Notifications
                  <span class="material-icons" style="font-size: 14px">arrow_forward</span>
                </a>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</header>
